import { HttpResponse } from 'msw';

import { DEVICE_TYPE } from '../constants';
import { getPortConfiguration } from '../helper';

type LegacyBody = { command?: string; access?: string };

export function handleLldpLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';
  const n = getPortConfiguration(DEVICE_TYPE).count;

  switch (command) {
    case 'get interfaces':
      if (access === 'get') {
        const list = Array.from({ length: n }, (_, i) => ({
          interface: i + 1,
          tx: Math.random() > 0.5,
        }));
        return HttpResponse.json(list, { status: 200 });
      }
      break;
    case 'set interfaces':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    case 'get neighbors':
      if (access === 'get') {
        return HttpResponse.json(
          {
            lldp: {
              interface: [
                {
                  interface: 1,
                  data: {
                    chassis: {
                      id: '00:11:22:33:44:55',
                      descr: 'Cisco Catalyst 2960',
                      type: 'macAddress',
                      value: '00:11:22:33:44:55',
                    },
                    port: {
                      id: { type: 'macAddress', value: '00:11:22:33:44:56' },
                      descr: 'GigabitEthernet0/1',
                    },
                    age: '120',
                  },
                },
                {
                  interface: 3,
                  data: {
                    chassis: {
                      id: '00:aa:bb:cc:dd:ee',
                      descr: 'HP ProCurve 2520',
                      type: 'macAddress',
                      value: '00:aa:bb:cc:dd:ee',
                    },
                    port: {
                      id: { type: 'macAddress', value: '00:aa:bb:cc:dd:ef' },
                      descr: 'Port 1',
                    },
                    age: '45',
                  },
                },
              ],
            },
          },
          { status: 200 },
        );
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for lldp:${command}` },
    { status: 400 },
  );
}
